import { useNavigate } from 'react-router-dom';

import { Dropdown, Menu } from '@arco-design/web-react';
import { IconDown } from '@arco-design/web-react/icon';
import { ROUTE_PATHS } from '@dmp/constant';

import { EXPERT_DATA_SERVICE_OPTIONS } from '../GlobalHeader.constants';
import type { ExpertDataServiceDropdownProps } from '../GlobalHeader.types';

/**
 * Expert Data Service dropdown component
 * Shows a dropdown menu with service options that all redirect to the data catalog
 */
export const ExpertDataServiceDropdown = ({ className }: ExpertDataServiceDropdownProps) => {
  const navigate = useNavigate();

  const handleMenuClick = (item: string) => {
    navigate(`${ROUTE_PATHS.DATA_CATALOG}?keyword=${encodeURIComponent(item)}`, {
      replace: window.location.pathname === ROUTE_PATHS.DATA_CATALOG,
    });
  };

  const dropdownMenu = (
    <Menu className="min-w-[180px]">
      {EXPERT_DATA_SERVICE_OPTIONS.map((option) => (
        <Menu.Item key={option.id} onClick={() => handleMenuClick(option.label)}>
          <span className="text-[#333] text-sm">{option.label}</span>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown droplist={dropdownMenu} trigger="click" position="bl">
      <div
        className={`flex items-center gap-1 cursor-pointer text-[#333] text-sm hover:text-[#0038FF] pb-1 ${className || ''}`}
      >
        <span>Expert Data Service</span>
        <IconDown className="text-[14px]" />
      </div>
    </Dropdown>
  );
};
